import { combineReducers } from 'redux';
import { StoryReducer } from '../reducers/storyReducer';
import { LoginReducer } from '../reducers/loginReducer';

export default combineReducers({
    StoryReducer,
    LoginReducer,
});